export const stringSetToSortedList = <T>(s: Set<string>): Array<T> => Array.from(s)
	.sort((a, b) => a?.localeCompare(b)) as Array<T>;
